import React from 'react';
import { motion } from 'framer-motion';

const SPACES = [
  {
    title: 'Lounge',
    description: 'Sala de espera y áreas de descanso',
    image: '/assets/Images/Loop lounge.jpg',
    slug: 'lounge',
  },
  {
    title: 'Oficina',
    description: 'Sillas, estaciones y mobiliario operativo',
    image: '/assets/Logos/mobiliario_oficina.jpg',
    slug: 'mobiliario-de-oficina',
  },
  {
    title: 'Multipropósito',
    description: 'Espacios versátiles y de alto tráfico',
    image: '/assets/Logos/zona_comercial.jpg',
    slug: 'multiproposito',
  },
  {
    title: 'Sofás y Bancos',
    description: 'Piezas de presencia y confort',
    image: '/assets/Logos/sofas_bancos_card.jpg',
    slug: 'sofas',
  },
];

const SpacesSection = () => {
  const openProducts = (slug) => {
    try {
      window.sessionStorage.setItem('verissa-home-category-slug', slug);
    } catch {
      // ignore
    }
    window.location.hash = 'productos';
  };

  return (
    <section className="home-spaces-section">
      <div className="container">
        <motion.div
          className="home-section-intro"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <h2 className="section-title">Espacios que resolvemos</h2>
          <p className="section-subtitle">
            Del lounge a la oficina: mobiliario y acabados para cada uso.
          </p>
        </motion.div>

        <div className="home-spaces-grid">
          {SPACES.map((space, index) => (
            <motion.button
              key={space.slug}
              type="button"
              className="home-space-card"
              onClick={() => openProducts(space.slug)}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: index * 0.07 }}
              whileHover={{ y: -6 }}
            >
              <div className="home-space-image">
                <img src={space.image} alt={space.title} />
              </div>
              <div className="home-space-content">
                <h3>{space.title}</h3>
                <p>{space.description}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpacesSection;
